const localUrl = "http://localhost:3001";
const deployUrl = "https://aais-kitchen-backend.onrender.com";

export { localUrl, deployUrl };
